import { StateData } from '..'

export const DEFAULT_DEBOUNCE_VALUE = 300
export const DEFAULT_ALLOWED_ADDRESS_TYPES = ['street_address', 'subpremise', 'premise']
export const DEFAULT_OPTIONAL_ADDRESS_FIELDS = ['address2']
export const INPUT_ADDRESS_DROPDOWN_MENU = 'input-address-dropdown-menu'

export const STATES: {
  [key: string]: StateData
} = {
  AU: {
    order: ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'],
    label: {
      ACT: 'ACT',
      NSW: 'NSW',
      NT: 'NT',
      QLD: 'QLD',
      SA: 'SA',
      TAS: 'TAS',
      VIC: 'VIC',
      WA: 'WA',
    },
  },
  CA: {
    order: ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
    label: {
      AB: 'AB',
      BC: 'BC',
      MB: 'MB',
      NB: 'NB',
      NL: 'NL',
      NT: 'NT',
      NS: 'NS',
      NU: 'NU',
      ON: 'ON',
      PE: 'PE',
      QC: 'QC',
      SK: 'SK',
      YT: 'YT',
    },
  },
  US: {
    order: [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'DC',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
    ],
    label: {
      AL: 'AL',
      AK: 'AK',
      AZ: 'AZ',
      AR: 'AR',
      CA: 'CA',
      CO: 'CO',
      CT: 'CT',
      DE: 'DE',
      DC: 'DC',
      FL: 'FL',
      GA: 'GA',
      HI: 'HI',
      ID: 'ID',
      IL: 'IL',
      IN: 'IN',
      IA: 'IA',
      KS: 'KS',
      KY: 'KY',
      LA: 'LA',
      ME: 'ME',
      MD: 'MD',
      MA: 'MA',
      MI: 'MI',
      MN: 'MN',
      MS: 'MS',
      MO: 'MO',
      MT: 'MT',
      NE: 'NE',
      NV: 'NV',
      NH: 'NH',
      NJ: 'NJ',
      NM: 'NM',
      NY: 'NY',
      NC: 'NC',
      ND: 'ND',
      OH: 'OH',
      OK: 'OK',
      OR: 'OR',
      PA: 'PA',
      RI: 'RI',
      SC: 'SC',
      SD: 'SD',
      TN: 'TN',
      TX: 'TX',
      UT: 'UT',
      VT: 'VT',
      VA: 'VA',
      WA: 'WA',
      WV: 'WV',
      WI: 'WI',
      WY: 'WY',
    },
    fullname: {
      AL: 'Alabama',
      AK: 'Alaska',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DC: 'District of Columbia',
      DE: 'Delaware',
      FL: 'Florida',
      GA: 'Georgia',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PA: 'Pennsylvania',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    },
  },
}

export const COUNTRIES_WITHOUT_POSTCODES: Array<string | undefined> = [
  'AO',
  'AG',
  'AW',
  'BS',
  'BZ',
  'BJ',
  'BM',
  'BO',
  'BQ',
  'BW',
  'BF',
  'BI',
  'CM',
  'CF',
  'TD',
  'KM',
  'CG',
  'CD',
  'CK',
  'CI',
  'CW',
  'DJ',
  'DM',
  'TL',
  'GQ',
  'ER',
  'FJ',
  'TF',
  'GA',
  'GM',
  'GD',
  'GY',
  'HM',
  'HK',
  'KI',
  'KP',
  'LY',
  'MO',
  'MW',
  'ML',
  'MR',
  'NA',
  'NR',
  'NL',
  'NU',
  'QA',
  'RW',
  'KN',
  'ST',
  'SC',
  'SL',
  'SX',
  'SB',
  'SS',
  'SR',
  'SY',
  'TG',
  'TK',
  'TO',
  'TV',
  'UG',
  'AE',
  'VU',
  'YE',
  'ZW',
]
